import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";

const SCROLL_THRESHOLD = 300;

const ScrollToTopButton = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={scrollToTop}
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          transition={{ duration: 0.2 }}
          title={t("buttons.scrollToTop")}
          aria-label={t("buttons.scrollToTop")}
          className="
            fixed bottom-6 end-6 z-[1000]
            flex h-11 w-11 items-center justify-center
            rounded-full bg-brand-500 text-white
            shadow-lg shadow-brand-500/30
            transition-colors hover:bg-brand-600
            focus:outline-none focus:ring-2 focus:ring-brand-400 focus:ring-offset-2
            dark:bg-brand-500 dark:hover:bg-brand-600
          "
        >
          <FaArrowUp size={16} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTopButton;
